import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { DialogModule } from 'primeng/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rentals-fixed-duration-config',
  templateUrl: './rentals-fixed-duration-config.component.html',
  styleUrls: ['./rentals-fixed-duration-config.component.scss'],
  providers: [MessageService],
})
export class RentalsFixedDurationConfigComponent implements OnInit {
  public priceGroupsDetail: any;
  public allowableTimeUnits: any;
  public showPriceGroup: boolean = false;
  public loadingPriceGroupsDetail: boolean = false;
  public loadingAllowableTimeUnits: boolean = false;
  public selectedPriceGroup: any = {};
  public showTimeUnitDialog: boolean = false;
  public savingTimeUnit: boolean = false;
  public removingTimeUnit: boolean = false;
  public selectedTimeUnit: any = {};
  public timeUnits: any = [
    { value: 1, label: 'Hour(s)' },
    { value: 2, label: 'Day(s)' },
    { value: 3, label: 'Week(s)' },
    { value: 4, label: 'Month(s)' },
  ];

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private dialog: DialogModule,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.getRentalAllowableTimeUnits();
    this.getRentalPriceGroupsDetail();
  }

  getRentalPriceGroupsDetail() {
    this.loadingPriceGroupsDetail = true;
    this.rentalsService
      .getRentalFixedPriceGroupsDetail(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.priceGroupsDetail = res;
          this.loadingPriceGroupsDetail = false;
        },
        (err) => {
          this.loadingPriceGroupsDetail = false;
        },
      );
  }

  getRentalAllowableTimeUnits() {
    this.loadingAllowableTimeUnits = true;
    this.rentalsService
      .getRentalAllowableTimeUnits(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.allowableTimeUnits = res;
          this.loadingAllowableTimeUnits = false;
        },
        (err) => {
          this.loadingAllowableTimeUnits = false;
        },
      );
  }

  addPriceGroup() {
    this.selectedPriceGroup = {
      name: '',
      description: '',
      allocatedTimePrice: this.allowableTimeUnits.map((x) => {
        return {
          unit: x.unit,
          unitTypeID: x.unitTypeID,
          unitType: x.unitType,
          quantity: 1,
          allowableTimeUnitID: x.id,
        };
      }),
      isActive: true,
      defaultPartnerID: this.helpersService.getPartnerId(),
    };
    this.showPriceGroup = true;
  }

  updatePriceGroup(priceGroup) {
    this.selectedPriceGroup = JSON.parse(JSON.stringify(priceGroup));
    this.showPriceGroup = true;
  }

  closePriceGroup() {
    this.showPriceGroup = false;
  }

  editTimeUnit(timeUnit) {
    this.selectedTimeUnit = JSON.parse(JSON.stringify(timeUnit));
    this.showTimeUnitDialog = true;
  }

  addTimeUnit() {
    this.selectedTimeUnit = {
      unit: 0,
      unitTypeID: 1,
      defaultPartnerID: this.helpersService.getPartnerId(),
    };
    this.showTimeUnitDialog = true;
  }

  isValid() {
    console.log(this.selectedTimeUnit);
    return (
      this.selectedTimeUnit.unit &&
      this.selectedTimeUnit.unit > 0 &&
      this.selectedTimeUnit.unitTypeID &&
      this.selectedTimeUnit.unitTypeID > 0
    );
  }

  saveTimeUnit() {
    this.savingTimeUnit = true;
    if (this.selectedTimeUnit.id) {
      this.rentalsService
        .updateRentalAllowableTimeUnit(this.selectedTimeUnit)
        .subscribe(
          (res) => {
            this.savingTimeUnit = false;
            this.showTimeUnitDialog = false;
            this.getRentalAllowableTimeUnits();
            this.getRentalPriceGroupsDetail();
          },
          (err) => {
            this.savingTimeUnit = false;
          },
        );
    } else {
      this.rentalsService
        .addRentalAllowableTimeUnit(this.selectedTimeUnit)
        .subscribe(
          (res) => {
            this.savingTimeUnit = false;
            this.showTimeUnitDialog = false;
            this.getRentalAllowableTimeUnits();
            this.getRentalPriceGroupsDetail();
          },
          (err) => {
            this.savingTimeUnit = false;
          },
        );
    }
  }

  removeTimeUnit() {
    this.removingTimeUnit = true;
    this.rentalsService
      .updateRentalAllowableTimeUnit({ ...this.selectedTimeUnit, isActive: 0 })
      .subscribe(
        (res) => {
          this.removingTimeUnit = false;
          this.showTimeUnitDialog = false;
          this.getRentalAllowableTimeUnits();
          this.getRentalPriceGroupsDetail();
        },
        (err) => {
          this.removingTimeUnit = false;
        },
      );
  }
}
